import { z } from 'zod';

/**
 * API input: accepts ISO strings from JSON or Date instances; output is always a JS Date for Prisma DateTime fields.
 */
export const zCoercedDate = z.union([z.string(), z.date()]).pipe(z.coerce.date());

export const zCoercedDateOptional = zCoercedDate.optional();

export const zCoercedDateNullable = zCoercedDate.nullable();

export const zCoercedDateOptionalNullable = zCoercedDate.optional().nullable();
